import { api } from '../../../utils/api'

const testimonialsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        testimonials: builder.query({
            query: () => '/exampleprovider/testimonials/',
        }),
    }),
})

export const { useTestimonialsQuery } = testimonialsApi
